module.exports = __webpack_public_path__ + "static/media/ic_vehicules.2a218a50.svg";